import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';

import {Button} from '../button/button';
import {EditIcon} from '../icon';
import {TextField} from '../textfield/textfield';

import {LinkedEntity} from './linked-entity';

type Props = {
    useEntityColor: boolean;
    stopPropagation: boolean;
    shouldClientRoute: boolean;
    isLinkable: boolean;
    htmlUrlPath: string;
    type: string;
    name: string;
    id: string;
    disableEditing?: boolean;
    handleSave?: (name: string) => void;
};

export function EditableLinkedEntity(props: Props) {
    const [name, setName] = React.useState(props.name);
    const [isEditing, setIsEditing] = React.useState(false);

    React.useEffect(() => {
        setName(props.name);
    }, [props.name]);

    const handleSave = () => {
        setIsEditing(false);
        props.handleSave?.(name);
    };

    return isEditing && !props.disableEditing ? (
        <div className='border-bottom'>
            <TextField
                size='medium'
                noPadding={true}
                noBorder={true}
                focusOnMount={true}
                fitContent={true}
                value={name}
                onChange={setName}
                onEnter={handleSave}
                // @ts-expect-error
                onBlur={handleSave}
            />
        </div>
    ) : (
        <Stack spacing={6} isHorizontal={true} alignItems='center'>
            <LinkedEntity
                useEntityColor={props.useEntityColor}
                stopPropagation={props.stopPropagation}
                shouldClientRoute={props.shouldClientRoute}
                isLinkable={props.isLinkable}
                htmlUrlPath={props.htmlUrlPath}
                type={props.type}
                name={name}
            />
            {!props.disableEditing && props.id && (
                <Button variant='text-primary' noPadding={true} onClick={() => setIsEditing(true)}>
                    <EditIcon size={15} wrapWithDiv={false} />
                </Button>
            )}
        </Stack>
    );
}
